import { ActionsCreators, connectToJava } from "@tipico/java-react-connector";
import { GlobalLanguage } from "../../components/GlobalLanguage/GlobalLanguage";

export interface LanguageContainerStreamProps {
    readonly screenSaverAndIdleTimeoutState: string;
}

export const IDLE_TIMEOUT_STREAM = "IdleTimeOut";

const INITIAL_STATE: LanguageContainerStreamProps = {
    screenSaverAndIdleTimeoutState: "initialValue"
};

const actionsCreators: ActionsCreators<{}> = {};

export default connectToJava<
    {},
    LanguageContainerStreamProps,
    {
        [IDLE_TIMEOUT_STREAM]: LanguageContainerStreamProps;
    },
    {}
>({
    actionsCreators,
    state: {
        [IDLE_TIMEOUT_STREAM]: INITIAL_STATE
    },
    stateMapper: ({ IdleTimeOut: state }) => state
})(GlobalLanguage);
